import './App.css';

import { useEffect, useState, useCallback } from "react";

function Binga({ token }) {
  const [expenses, setExpenses] = useState([]);
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [expenseForm, setExpenseForm] = useState({ name: "", value: "", category: "", account: "", group: "", expense_date: "", need_to_pay: false, _id: null });
  const [incomeForm, setIncomeForm] = useState({ name: "", value: "", income_date: "", _id: null });

  const API_URL = process.env.REACT_APP_API_URL; // change selon ton backend

  const [budgets, setBudgets] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState(null);


  // fetch budget 
  const fetchBudgets = useCallback(async () => {
    // On s'assure de ne rien faire si le jeton n'est pas présent
    if (!token) {
      console.error("Tentative de fetch des budgets sans jeton.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/budget`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      // Gérer les réponses d'erreur (ex: 401 Unauthorized)
      if (!res.ok) {
        throw new Error(`Erreur du serveur: ${res.status}`);
      }

      const data = await res.json();

      // trier par start_date croissant
      const sorted = data.sort(
        (a, b) =>
          new Date(b.start_date).getTime() - new Date(a.start_date).getTime() 
      );
      setBudgets(sorted);
    } catch (err) {
      console.error("Erreur fetch budgets:", err);
    }
  }, [token, API_URL]);

  // --- Fetch Expenses ---
  const fetchExpenses = useCallback(async () => {
    const res = await fetch(`${API_URL}/expenses?start_date=${selectedBudget.start_date}&end_date=${selectedBudget.end_date}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await res.json();
    // Tri par group puis par category
    data.sort((a, b) => {
      if (a.group === b.group) {
        return a.category.localeCompare(b.category);
      }
      return a.group.localeCompare(b.group);
    });
    setExpenses(data);
  }, [selectedBudget, token, API_URL]);

  // --- Fetch Incomes ---
  const fetchIncomes = useCallback(async () => {
    const res = await fetch(`${API_URL}/income?start_date=${selectedBudget.start_date}&end_date=${selectedBudget.end_date}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await res.json();
    setIncomes(data);
  }, [selectedBudget, token, API_URL]);


  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchBudgets();
      // await fetchExpenses();
      // await fetchIncomes();
      setLoading(false);
    };
    load();
  }, [fetchBudgets]);

  useEffect(() => {
    if (!selectedBudget) return;

    const fetchData = async () => {
      await fetchExpenses();
      await fetchIncomes();
    };

    fetchData();
  }, [selectedBudget, fetchExpenses, fetchIncomes]);

  const totalIncomes = incomes.reduce((sum, i) => sum + i.value, 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + e.value, 0);
  const balance = totalIncomes - totalExpenses;
  const targets = {
    fix: 65,
    Envie: 20,
    Investissement: 15,
  };

  // //gestion par budget 
  // const loadData = async (budgetId) => {

  // };





  // Regroupement par group
  const grouped = expenses.reduce((acc, e) => {
    const g = e.group || "Autres";
    acc[g] = (acc[g] || 0) + e.value;
    return acc;
  }, {});
  // Convertir en tableau exploitable
  const rows = Object.entries(grouped).map(([group, sum]) => {
    const percentage = totalExpenses ? (sum / totalExpenses) * 100 : 0;
    const target = targets[group] ?? 0;
    let colorClass = "bg-white";

    if (group in targets) {
      if (group === "Investissement") {
        colorClass = percentage < target ? "bg-red-200" : "bg-green-100";
      } else {
        colorClass = percentage > target ? "bg-red-200" : "bg-green-100";
      }
    } else {
      colorClass = "bg-purple-200";
    }

    return {
      group,
      sum,
      percentage,
      target,
      colorClass,
    };
  });

  // Tableau 1 : comptes avec total des dépenses
  const accountTotals = expenses.reduce((acc, e) => {
    const account = e.account || "Sans compte";
    acc[account] = (acc[account] || 0) + e.value;
    return acc;
  }, {});

  // Tableau 2 : expenses avec need_to_pay = true
  const toPayExpenses = expenses.filter((e) => e.need_to_pay);


  // --- Create / Update Expense ---
  const saveExpense = async (e) => {
    e.preventDefault();
    if (expenseForm._id) {
      await fetch(`${API_URL}/expenses/${expenseForm._id}`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(expenseForm),
      });
    } else {
      await fetch(`${API_URL}/expenses`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(expenseForm),
      });
    }
    setExpenseForm({ name: "", value: "", category: "", account: "", group: "", expense_date: "", need_to_pay: false, _id: null });
    fetchExpenses();
  };

  // --- Delete Expense ---
  const deleteExpense = async (id) => {
    await fetch(`${API_URL}/expenses/${id}`, {
      method: "DELETE",
      headers: { 'Authorization': `Bearer ${token}` }
    });
    fetchExpenses();
  };

  // --- Create / Update Income ---
  const saveIncome = async (e) => {
    e.preventDefault();
    if (incomeForm._id) {
      await fetch(`${API_URL}/income/${incomeForm._id}`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(incomeForm),
      });
    } else {
      await fetch(`${API_URL}/income`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(incomeForm),
      });
    }
    setIncomeForm({ name: "", value: "", income_date: "", _id: null });
    fetchIncomes();
  };

  // --- Delete Income ---
  const deleteIncome = async (id) => {
    await fetch(`${API_URL}/income/${id}`, {
      method: "DELETE",
      headers: { 'Authorization': `Bearer ${token}` }
    });
    fetchIncomes();
  };

  const formatDateInput = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().split("T")[0];
  };



  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateForm, setDuplicateForm] = useState({
    name: "",
    start_date: "",
    end_date: ""
  });

  const [showExpenseModal, setShowExpenseModal] = useState(false);

  const handleDuplicateBudget = async (e) => {
    e.preventDefault();
    if (!selectedBudget) return;

    try {
      const queryParams = new URLSearchParams({
        new_budget_name: duplicateForm.name,
        new_start_date: duplicateForm.start_date,
        new_end_date: duplicateForm.end_date
      });

      const res = await fetch(`${API_URL}/budget/${selectedBudget._id}/duplicate?${queryParams}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        throw new Error(`Erreur lors de la duplication: ${res.status}`);
      }

      const newBudget = await res.json();

      // Refresh budgets and select the new one
      await fetchBudgets();
      setSelectedBudget(newBudget);
      setShowDuplicateModal(false);
      setDuplicateForm({ name: "", start_date: "", end_date: "" });

    } catch (err) {
      console.error("Erreur duplication budget:", err);
      alert("Erreur lors de la duplication du budget");
    }
  };

  if (loading) return <div className="p-4">Loading...</div>;

  return (

    <div className="p-6 bg-gray-100 min-h-screen space-y-10">
      {/* Sélecteur de budget */}
      <div className="flex items-center gap-4">
        <label className="text-lg font-semibold text-gray-700">Sélectionner un budget :</label>
        <select
          value={selectedBudget?._id || ""}
          onChange={(e) => {
            const selected = budgets.find((b) => b._id === e.target.value);
            setSelectedBudget(selected || null);
          }}
          className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white text-gray-700 hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600"
        >
          <option value="">-- Choisir un budget --</option>
          {budgets.map((budget) => (
            <option key={budget._id} value={budget._id}>
              {budget.name}
            </option>
          ))}
        </select>
      </div>

      {selectedBudget && (
        <>
          <div className="flex justify-end">
            <button
              onClick={() => {
                setDuplicateForm({
                  name: `${selectedBudget.name} (Copie)`,
                  start_date: "",
                  end_date: ""
                });
                setShowDuplicateModal(true);
              }}
              className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
            >
              Dupliquer le Budget
            </button>
          </div>

          {/* Duplicate Modal */}
          {showDuplicateModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-xl w-96">
                <h2 className="text-xl font-bold mb-4">Dupliquer le Budget</h2>
                <form onSubmit={handleDuplicateBudget} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nouveau Nom</label>
                    <input
                      type="text"
                      required
                      className="w-full border p-2 rounded"
                      value={duplicateForm.name}
                      onChange={e => setDuplicateForm({ ...duplicateForm, name: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date de début</label>
                    <input
                      type="date"
                      required
                      className="w-full border p-2 rounded"
                      value={duplicateForm.start_date}
                      onChange={e => setDuplicateForm({ ...duplicateForm, start_date: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date de fin</label>
                    <input
                      type="date"
                      required
                      className="w-full border p-2 rounded"
                      value={duplicateForm.end_date}
                      onChange={e => setDuplicateForm({ ...duplicateForm, end_date: e.target.value })}
                    />
                  </div>
                  <div className="flex justify-end space-x-2 mt-6">
                    <button
                      type="button"
                      onClick={() => setShowDuplicateModal(false)}
                      className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                    >
                      Annuler
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      Valider
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div className="grid grid-cols-3 gap-6 mt-6">
            {/* Incomes */}
            <div className="bg-green-100 text-green-800 p-6 rounded-2xl shadow">
              <h3 className="text-lg font-bold">Total Incomes</h3>
              <p className="text-2xl font-extrabold">{totalIncomes.toFixed(2)} €</p>
            </div>

            {/* Expenses */}
            <div className="bg-red-100 text-red-800 p-6 rounded-2xl shadow">
              <h3 className="text-lg font-bold">Total Expenses</h3>
              <p className="text-2xl font-extrabold">{totalExpenses.toFixed(2)} €</p>
            </div>

            {/* Balance */}
            <div
              className={`p-6 rounded-2xl shadow ${balance >= 0 ? "bg-blue-100 text-blue-800" : "bg-orange-100 text-orange-800"
                }`}
            >
              <h3 className="text-lg font-bold">Balance</h3>
              <p className="text-2xl font-extrabold">{balance.toFixed(2)} €</p>
            </div>

          </div>

          <div className="grid grid-cols-3 gap-6 mt-6">

            <div className="mt-8">
              <h2 className="text-xl font-bold mb-4">Dépenses par Group</h2>
              <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="px-4 py-2 text-left">Group</th>
                    <th className="px-4 py-2 text-right">Somme</th>
                    <th className="px-4 py-2 text-right">%</th>
                    <th className="px-4 py-2 text-right">Cible</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.group} className={`${row.colorClass}`}>
                      <td className="px-4 py-2">{row.group}</td>
                      <td className="px-4 py-2 text-right">{row.sum.toFixed(2)}</td>
                      <td className="px-4 py-2 text-right">{row.percentage.toFixed(1)}%</td>
                      <td className="px-4 py-2 text-right">{row.target}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-8">
              {/* Tableau des virements */}
              <h2 className="text-xl font-bold mb-4">Comptes et Totaux des Dépenses</h2>
              <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden mb-8">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="px-4 py-2 text-left">Compte</th>
                    <th className="px-4 py-2 text-right">Total Dépenses</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(accountTotals).map(([account, total]) => (
                    <tr key={account} className="bg-white">
                      <td className="px-4 py-2">{account}</td>
                      <td className="px-4 py-2 text-right">{total.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-8">

              {/* Tableau des payement à faire */}
              <h2 className="text-xl font-bold mb-4">Dépenses à Payer (need_to_pay)</h2>
              <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="px-4 py-2 text-left">Nom</th>
                    <th className="px-4 py-2 text-left">Compte</th>
                    <th className="px-4 py-2 text-right">Montant</th>
                  </tr>
                </thead>
                <tbody>
                  {toPayExpenses.map((exp) => (
                    <tr key={exp._id} className="bg-yellow-100">
                      <td className="px-4 py-2">{exp.name}</td>
                      <td className="px-4 py-2">{exp.account || "Sans compte"}</td>
                      <td className="px-4 py-2 text-right">{exp.value.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


          </div>


          {/* --- Expenses Table --- */}
          <div className="bg-white p-4 rounded shadow">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Expenses</h2>
              <button
                onClick={() => {
                  setExpenseForm({ name: "", value: "", category: "", account: "", group: "", expense_date: "", need_to_pay: false, _id: null });
                  setShowExpenseModal(true);
                }}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              >
                + Ajouter Dépense
              </button>
            </div>

            {/* Expense Modal */}
            {showExpenseModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl w-96 max-h-96 overflow-y-auto">
                  <h2 className="text-xl font-bold mb-4">{expenseForm._id ? "Modifier Dépense" : "Ajouter Dépense"}</h2>
                  <form onSubmit={(e) => {
                    saveExpense(e);
                    setShowExpenseModal(false);
                  }} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nom</label>
                      <input type="text" placeholder="Name" className="w-full border p-2 rounded" value={expenseForm.name} onChange={e => setExpenseForm({ ...expenseForm, name: e.target.value })} required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Montant</label>
                      <input type="number" placeholder="Value" className="w-full border p-2 rounded" value={expenseForm.value} onChange={e => setExpenseForm({ ...expenseForm, value: e.target.value })} required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Catégorie</label>
                      <input type="text" placeholder="Category" className="w-full border p-2 rounded" value={expenseForm.category} onChange={e => setExpenseForm({ ...expenseForm, category: e.target.value })} required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Compte</label>
                      <input type="text" placeholder="Account" className="w-full border p-2 rounded" value={expenseForm.account} onChange={e => setExpenseForm({ ...expenseForm, account: e.target.value })} required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Groupe</label>
                      <input type="text" placeholder="Group" className="w-full border p-2 rounded" value={expenseForm.group} onChange={e => setExpenseForm({ ...expenseForm, group: e.target.value })} required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                      <input type="date" className="w-full border p-2 rounded" value={formatDateInput(expenseForm.expense_date)} onChange={e => setExpenseForm({ ...expenseForm, expense_date: e.target.value })} required />
                    </div>
                    <div className="flex items-center gap-2">
                      <input type="checkbox" id="needToPay" checked={expenseForm.need_to_pay} onChange={e => setExpenseForm({ ...expenseForm, need_to_pay: e.target.checked })} />
                      <label htmlFor="needToPay" className="text-sm font-medium text-gray-700">À payer</label>
                    </div>
                    <div className="flex justify-end space-x-2 mt-6">
                      <button
                        type="button"
                        onClick={() => setShowExpenseModal(false)}
                        className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                      >
                        Annuler
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                      >
                        {expenseForm._id ? "Modifier" : "Ajouter"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            <table className="w-full table-auto border-collapse border">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-2 py-1">Name</th>
                  <th className="border px-2 py-1">Value</th>
                  <th className="border px-2 py-1">Category</th>
                  <th className="border px-2 py-1">Account</th>
                  <th className="border px-2 py-1">Group</th>
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">Need to Pay</th>
                  <th className="border px-2 py-1">Actions</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map(exp => (
                  <tr key={exp._id}>
                    <td className="border px-2 py-1">{exp.name}</td>
                    <td className="border px-2 py-1">{exp.value}</td>
                    <td className="border px-2 py-1">{exp.category}</td>
                    <td className="border px-2 py-1">{exp.account}</td>
                    <td className="border px-2 py-1">{exp.group}</td>
                    <td className="border px-2 py-1">{new Date(exp.expense_date).toLocaleDateString()}</td>
                    <td className="border px-2 py-1">{exp.need_to_pay ? "Yes" : "No"}</td>
                    <td className="border px-2 py-1 space-x-1">
                      <button onClick={() => {
                        setExpenseForm(exp);
                        setShowExpenseModal(true);
                      }} className="bg-yellow-400 px-2 py-1 rounded">Edit</button>
                      <button onClick={() => deleteExpense(exp._id)} className="bg-red-500 text-white px-2 py-1 rounded">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* --- Incomes Table --- */}
          <div className="bg-white p-4 rounded shadow">
            <h2 className="text-xl font-bold mb-4">Incomes</h2>
            <form onSubmit={saveIncome} className="flex flex-wrap gap-2 mb-4">
              <input type="text" placeholder="Name" className="border p-1 rounded" value={incomeForm.name} onChange={e => setIncomeForm({ ...incomeForm, name: e.target.value })} required />
              <input type="number" placeholder="Value" className="border p-1 rounded" value={incomeForm.value} onChange={e => setIncomeForm({ ...incomeForm, value: e.target.value })} required />
              <input type="date" className="border p-1 rounded" value={formatDateInput(incomeForm.income_date)} onChange={e => setIncomeForm({ ...incomeForm, income_date: e.target.value })} required />
              <button type="submit" className="bg-blue-500 text-white px-3 py-1 rounded">{incomeForm._id ? "Update" : "Add"}</button>
            </form>
            <table className="w-full table-auto border-collapse border">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-2 py-1">Name</th>
                  <th className="border px-2 py-1">Value</th>
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">Actions</th>
                </tr>
              </thead>
              <tbody>
                {incomes.map(inc => (
                  <tr key={inc._id}>
                    <td className="border px-2 py-1">{inc.name}</td>
                    <td className="border px-2 py-1">{inc.value}</td>
                    <td className="border px-2 py-1">{new Date(inc.income_date).toLocaleDateString()}</td>
                    <td className="border px-2 py-1 space-x-1">
                      <button onClick={() => setIncomeForm(inc)} className="bg-yellow-400 px-2 py-1 rounded">Edit</button>
                      <button onClick={() => deleteIncome(inc._id)} className="bg-red-500 text-white px-2 py-1 rounded">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default Binga;
